import * as ActionTypes from 'constants';

export const client = (state = { address : {} }, action) => {
	let {type, payload} = action;

  switch(type) {
    case ActionTypes.CLEAR_CLIENT:
      return { address : {}}
    case ActionTypes.ADD_CLIENT_TASK:
      return { ...state, tasks: [...state.tasks || [], payload.task] };
    case ActionTypes.DELETE_CLIENT_TASK:
    	return {...state, tasks: (state.tasks || []).filter(t => t._id !== payload.task_id)}
    case ActionTypes.ADD_CLIENT_INTERACTION:
      return { ...state, interactions: [...state.interactions, payload.interaction] };
    case ActionTypes.RECEIVE_CLIENT:
      return (payload || {});
    case ActionTypes.UPDATE_CLIENT_TASK:
      let tasks = state.tasks.slice().map((task, idx) => {
        if(task._id == payload.task._id) {
          task = payload.task;
        }
        return task;
      });
      return { ...state, tasks: tasks };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/common/reducers/client.js